// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"aaaf5edb","336":"fabb1c1a","429":"20c142bf","937":"6faf6c9a"}[chunkId] + ".js";
};